import {
  HEX,
  Targeting
} from "../../../src";
import { SEC } from "../../../src";
import { bless_atk_condition } from "../../conditions/battle-blessing";
const bless_atk = {
  slug: "bless_atk",
  name: "Battle Blessing",
  abilityIcon: "bless_atk",
  description: "Imbues an ally with fiery power, sharpening their strikes",
  costs: [{ stat: "mana", value: 18 }],
  targeting: Targeting.SingleAlly,
  cooldown: SEC(6),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          addConditions: [
            {
              slug: "bless_atk",
              name: "Battle Blessing",
              tags: ["buff"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "buff", "gold"]
};
export {
  bless_atk,
  bless_atk_condition
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vbGliL2FiaWxpdGllcy9wYWxhZGluL2JsZXNzLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQge1xuICBBY3Rpb25EZWZpbml0aW9uLFxuICBIRVgsXG4gIFNDQUxJTkcsXG4gIFRhcmdldGluZyxcbn0gZnJvbSAnLi4vLi4vLi4vc3JjJztcbmltcG9ydCB7IFNFQyB9IGZyb20gJy4uLy4uLy4uL3NyYyc7XG5pbXBvcnQgeyBibGVzc19hdGtfY29uZGl0aW9uIH0gZnJvbSAnLi4vLi4vY29uZGl0aW9ucy9iYXR0bGUtYmxlc3NpbmcnO1xuXG5leHBvcnQgeyBibGVzc19hdGtfY29uZGl0aW9uIH07XG5cbmV4cG9ydCBjb25zdCBibGVzc19hdGs6IEFjdGlvbkRlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdibGVzc19hdGsnLFxuICBuYW1lOiAnQmF0dGxlIEJsZXNzaW5nJyxcbiAgYWJpbGl0eUljb246ICdibGVzc19hdGsnLFxuICBkZXNjcmlwdGlvbjpcbiAgICAnSW1idWVzIGFuIGFsbHkgd2l0aCBmaWVyeSBwb3dlciwgc2hhcnBlbmluZyB0aGVpciBzdHJpa2VzJyxcbiAgY29zdHM6IFt7IHN0YXQ6ICdtYW5hJywgdmFsdWU6IDE4IH1dLFxuICB0YXJnZXRpbmc6IFRhcmdldGluZy5TaW5nbGVBbGx5LFxuICBjb29sZG93bjogU0VDKDYpLFxuICBpbXBhY3RTY2hlZHVsZToge1xuICAgIFswXTogW1xuICAgICAge1xuICAgICAgICBoZXhlczogSEVYLkRPVCxcbiAgICAgICAgZWZmZWN0OiB7XG4gICAgICAgICAgYWRkQ29uZGl0aW9uczogW1xuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBzbHVnOiAnYmxlc3NfYXRrJyxcbiAgICAgICAgICAgICAgbmFtZTogJ0JhdHRsZSBCbGVzc2luZycsXG4gICAgICAgICAgICAgIHRhZ3M6IFsnYnVmZiddLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIHJlbW92ZUNvbmRpdGlvbnNCeVRhZzogW10sXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIF0sXG4gIH0sXG4gIHRhZ3M6IFsnc3BlbGwnLCAncmFuZ2VkJywgJ2J1ZmYnLCAnZ29sZCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUFBO0FBQUEsRUFFRTtBQUFBLEVBRUE7QUFBQSxPQUNLO0FBQ1AsU0FBUyxXQUFXO0FBQ3BCLFNBQVMsMkJBQTJCO0FBSTdCLE1BQU0sWUFBOEI7QUFBQSxFQUN6QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixhQUNFO0FBQUEsRUFDRixPQUFPLENBQUMsRUFBRSxNQUFNLFFBQVEsT0FBTyxHQUFHLENBQUM7QUFBQSxFQUNuQyxXQUFXLFVBQVU7QUFBQSxFQUNyQixVQUFVLElBQUksQ0FBQztBQUFBLEVBQ2YsZ0JBQWdCO0FBQUEsSUFDZCxDQUFDLENBQUMsR0FBRztBQUFBLE1BQ0g7QUFBQSxRQUNFLE9BQU8sSUFBSTtBQUFBLFFBQ1gsUUFBUTtBQUFBLFVBQ04sZUFBZTtBQUFBLFlBQ2I7QUFBQSxjQUNFLE1BQU07QUFBQSxjQUNOLE1BQU07QUFBQSxjQUNOLE1BQU0sQ0FBQyxNQUFNO0FBQUEsWUFDZjtBQUFBLFVBQ0Y7QUFBQSxVQUNBLHVCQUF1QixDQUFDO0FBQUEsUUFDMUI7QUFBQSxNQUNGO0FBQUEsSUFDRjtBQUFBLEVBQ0Y7QUFBQSxFQUNBLE1BQU0sQ0FBQyxTQUFTLFVBQVUsUUFBUSxNQUFNO0FBQzFDOyIsCiAgIm5hbWVzIjogW10KfQo=
